import type { AssistantSkill } from '~/data/api/client'

import { type FocusedContextRef, toFocusedContextRef } from './contextRef'

export const PLATFORM_TOOL_NAMES = [
  'list_operations',
  'query',
  'search_docs',
  'get_charger_meter_values'
] as const

export type SkillShareScope = 'builtin' | 'personal' | 'organization'

export function skillShareScope(skill: AssistantSkill): SkillShareScope {
  if (skill.shareScope === 'personal') return 'personal'
  if (skill.shareScope === 'organization') return 'organization'
  return 'builtin'
}

export function isBuiltinSkill(skill: AssistantSkill): boolean {
  return skill.builtin === true || skillShareScope(skill) === 'builtin'
}

export function canEditSkill(skill: AssistantSkill): boolean {
  return !isBuiltinSkill(skill) && Boolean(skill.id)
}

export function mergeSkillContextRefs(
  previous: FocusedContextRef[],
  skill: AssistantSkill
): FocusedContextRef[] {
  if (!skill.defaultContextRefs?.length) return previous
  const next = [...previous]
  for (const raw of skill.defaultContextRefs) {
    const ref = toFocusedContextRef(raw)
    if (!ref) continue
    const exists = next.some((item) => item.type === ref.type && item.id === ref.id)
    if (!exists) next.push(ref)
  }
  return next
}
